@for (option of enumValues; track option.value; let i = $index) {
  <div class="love-it-radio">
    <input
      [formControl]="formControl"
      type="radio"
      [id]="unique + i"
      [value]="option[bindValue]"
      class="form-check-input"
      [name]="unique" />
    <label
      class="form-check-label"
      [for]="unique + i"
      >{{ option[bindLabel] }}</label
    >
  </div>
}
